import React from 'react'
import PropTypes from 'prop-types'
import i18n from '@pureartisan/simple-i18n'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import { VarIcon } from '../../../assets/Icons'
import clsx from 'clsx'
import Tooltip from '../Tooltip'
import _ from 'lodash'

// Styles for component.
const useVariabilityWarningStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    flexShrink: 0,
    '& .MuiTypography-root': {
      lineHeight: '17px',
      paddingLeft: '4px',
      paddingRight: theme.spacing(0.75),
    },
    '& svg': {
      height: '17px',
    },
  },
}))

const VariabilityWarning = ({
  variabilityLevel,
  activeGeoType,
  text,
  metric,
}) => {
  const classes = useVariabilityWarningStyles()

  // includes case where = 0
  if (!variabilityLevel) {
    return null
  }

  const langStrings = [
    ,
    'LITTLE_VARIABILITY',
    'SOME_VARIABILITY',
    'HIGH_VARIABILITY',
  ]
  const variabilityText = _.isUndefined(text)
    ? i18n.translate(langStrings[variabilityLevel])
    : text

  const tooltipStrings = [
    ,
    'LITTLE_VARIABILITY_TOOLTIP',
    'SOME_VARIABILITY_TOOLTIP',
    'HIGH_VARIABILITY_TOOLTIP',
  ]
  const tooltipText = i18n.translate(
    tooltipStrings[variabilityLevel],
    {
      metric: i18n.translate(`LABEL_FULL_${metric}`),
      geoType: i18n.translate(
        `GEO_TYPE_SIMPLE_SINGULAR_${activeGeoType}`,
      ),
    },
  )

  return (
    <Box
      className={clsx(classes.root, 'variability-warning')}
    >
      {!!variabilityText && (
        <Typography variant="caption">
          {variabilityText}
        </Typography>
      )}
      <Tooltip title={tooltipText}>
        <VarIcon variabilityLevel={variabilityLevel} />
      </Tooltip>
    </Box>
  )
}

VariabilityWarning.propTypes = {
  variabilityLevel: PropTypes.number,
  metric: PropTypes.string,
}

VariabilityWarning.defaultProps = {}

export default VariabilityWarning
